export default "__VITE_ASSET__BEbbFK8H__"